import(/* webpackMode: "eager" */ "/codebuild/output/src3170788350/src/apps/web/app/[locale]/error.tsx");
